import script from "./CardDetalhesTelao.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDetalhesTelao.vue?vue&type=script&setup=true&lang=js"

import "./CardDetalhesTelao.vue?vue&type=style&index=0&id=544f65ec&lang=css"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCarousel,QCarouselSlide,QImg,QSpinner});
